module.exports = __webpack_public_path__ + "img/video-click-button.11875bd.png";